import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { columns } from 'pages/orders/table/columns';
import Checkbox from '@material-ui/core/Checkbox';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: '#000000',
    fontWeight: 'bold',
    fontSize: 11.5,
  },
}))(TableCell);

const BlackCheckbox = withStyles({
  root: {
    color: '#000',
    padding: 0,
    '&$checked': {
      color: '#000',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const OrderTableHead = ({ category, toggleOrderForPayment }) => {
  const newColumns =
    category === 'PendingDetails'
      ? [
          ...columns,
          {
            id: 'void',
            label: 'Void',
            minWidth: 100,
          },
        ]
      : category === 'AwaitingPayment'
      ? [
          {
            id: 'checkbox',
            align: 'center',
          },
          ,
          ...columns,
          {
            id: 'copyOrder',
            label: 'Duplicate Order',
            minWidth: 100,
          },
          {
            id: 'vendorReferenceNumber',
            label: 'Vendor Reference Number',
          },
        ]
      : category === 'InProduction'
      ? [
          {
            id: 'checkbox',
            align: 'center',
          },
          ...columns,
          {
            id: 'vendorReferenceNumber',
            label: 'Vendor Reference Number',
          },
        ]
      : columns;

  return (
    <TableHead>
      <TableRow>
        {newColumns.map((column, index) => (
          <StyledTableCell
            key={`${column.id}thead${index}`}
            align={column.align}
            style={{ minWidth: column.minWidth }}
          >
            {column?.id === 'checkbox' ? (
              <BlackCheckbox
                onChange={(e) => toggleOrderForPayment(-1, e.target.checked)}
              />
            ) : (
              column.label
            )}
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default OrderTableHead;
